import classNames from 'classnames';

import IFormatIcon, { FormatIconSize } from './types';
import useStyles from './styles';

function FormatIcon({
  children,
  className,
  format,
  foldBg = '#ffffff',
  size = FormatIconSize.LARGE,
}: IFormatIcon) {
  const classes = useStyles({ format, size, foldBg });

  return (
    <div
      className={classNames(
        classes.note,
        'rounded',
        {
          small: size === FormatIconSize.SMALL,
          large: size === FormatIconSize.LARGE,
          medium: size === FormatIconSize.MEDIUM,
        },
        className,
      )}
    >
      {children || <div className={classes.noteContent}>{format}</div>}
    </div>
  );
}

export default FormatIcon;
